import { sqliteTable, text, real } from "drizzle-orm/sqlite-core";
import { rentalBookings } from "./rental-bookings";

// ============================================================================
// rental_pickups — เอกสารรับรถ (Pickup document) — renamed from rental_releases
// in #420 phase 3. The "release" term lives on only in the 001_initial.ts
// migration (historical) and the 002 rename migration.
// ============================================================================
export const rentalPickups = sqliteTable("car_rental_rental_pickups", {
  id: text("id").primaryKey(), // ULID
  pickupNo: text("pickup_no").notNull().unique(),
  bookingId: text("booking_id").notNull().references(() => rentalBookings.id), // FK → rental_bookings
  actualPickupDatetime: text("actual_pickup_datetime").notNull(),
  pickedUpBy: text("picked_up_by"), // FK → users
  mileageOut: real("mileage_out"),
  fuelLevelOut: text("fuel_level_out", {
    enum: ["empty", "1/4", "1/2", "3/4", "full"],
  }),
  vehicleCondition: text("vehicle_condition"),
  existingDamageNotes: text("existing_damage_notes"),
  pickupRemarks: text("pickup_remarks"),
  status: text("status", {
    enum: ["submitted", "cancelled"],
  }).notNull().default("submitted"),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

export type RentalPickup = typeof rentalPickups.$inferSelect;
export type NewRentalPickup = typeof rentalPickups.$inferInsert;
